import { AlertTriangle } from "lucide-react";
import { useAuthedSrc } from "@/lib/authedImage";

export const Warnings = ({ items, testid, compact }) => (items?.length ? (
  <div className="space-y-1" data-testid={testid}>
    {items.map((w) => (
      <p key={w.allergen} className={`flex items-start gap-1.5 font-bold ${compact ? "text-[11px]" : "text-sm"}`} style={{ color: "rgb(var(--st-red))" }}>
        <AlertTriangle className={`${compact ? "h-3 w-3" : "h-4 w-4"} mt-0.5 shrink-0`} /> {w.text.replace(/^⚠\s*/, "⚠ ")}
      </p>
    ))}
  </div>
) : null);

export const RecipeThumb = ({ hubId, recipe, size = "h-14 w-14" }) => {
  const src = useAuthedSrc(recipe?.photo_id ? `/organizations/${hubId}/meals/photos/${recipe.photo_id}` : null);
  return (
    <span className={`${size} inline-flex shrink-0 items-center justify-center overflow-hidden rounded-2xl bg-[rgba(var(--glow-lists),0.12)] text-2xl`}>
      {src ? <img src={src} alt="" className="h-full w-full object-cover" /> : (recipe?.emoji || "🍽️")}
    </span>
  );
};
